export const AlfatekLogo = ({ className = "h-9", onDark = false }) => (
    <div className={`inline-flex items-stretch ${className}`} aria-label="ALFATEK">
        <div className="w-3 bg-brand-yellow" />
        <div className={`px-3 flex items-center ${onDark ? "bg-transparent" : "bg-brand-blue"}`}>
            <span className="font-heading font-black tracking-tight text-white text-xl leading-none">ALFATEK</span>
        </div>
    </div>
);

export default AlfatekLogo;
